import { CombinedMessage } from '@/services/messages';
import { UiMessage } from '@/types/message';

export const keyOf = (accountId: string | number, chatId: string | number) =>
  `${accountId}:${chatId}`;
export const pendingKeyOf = (accountId: string | number) => `pending:${accountId}`;

export const mapCombinedToUi = (rows: CombinedMessage[]): UiMessage[] =>
  rows.map(r => ({
    id: String(r.id),
    role: 'assistant',
    content: r.ai_reply,
    structured: (r.ai_reply_structured as UiMessage['structured']) ?? null,
    timestamp: r.created_at ? new Date(r.created_at) : new Date(),
    title: r.user_request,
  }));

export const isCombinedMessageLike = (value: unknown): value is CombinedMessage =>
  typeof value === 'object' && value !== null && 'ai_reply' in value && 'user_request' in value;
